// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cqi5lJDHnVd3otinppUO {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  min-width: 280px;
  max-width: 360px;
  max-height: 80vh;
  overflow-y: scroll;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  font-size: 13px;
  color: var(--vnsc-text-primary, #e0e0e0);
}

.cqi5lJDHnVd3otinppUO::-webkit-scrollbar {
  width: 6px;
}

.cqi5lJDHnVd3otinppUO::-webkit-scrollbar-track {
  background: transparent;
}

.cqi5lJDHnVd3otinppUO::-webkit-scrollbar-thumb {
  background: var(--vnsc-text-muted, #64748b);
  border-radius: 3px;
}

.AuEMYFldJNgHfFqSsbzH {
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.AuEMYFldJNgHfFqSsbzH:last-child {
  border-bottom: none;
}

.BG7ycaHZ_5XZbLTn4QGK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  cursor: pointer;
  user-select: none;
}

.zEvYc1yD3q8BTJXdBXT8 {
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vnsc-text-secondary, #a0a0a0);
}

.SJ46B69dTrZRCluRjCLL {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}

.SJ46B69dTrZRCluRjCLL:hover {
  background: var(--vnsc-bg-hover, #232838);
  border-color: var(--vnsc-border, #2a2a2a);
}

.SJ46B69dTrZRCluRjCLL.CdkqT2_DTKiDaSzFRzto {
  background: var(--vnsc-bg-hover, #232838);
  border-color: var(--vnsc-accent, #2962ff);
}

.POyYWUNhynn7c1zGVhkm,
.cgg3EGQmYgKCfFP22ZXQ {
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.LYB9ngFbNmcXnnLmfzOR {
  font-variant-numeric: tabular-nums;
}

.SoGd_UTNZLyccp28uCsO {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  transition: transform 0.15s;
}

.SJ46B69dTrZRCluRjCLL.CdkqT2_DTKiDaSzFRzto .SoGd_UTNZLyccp28uCsO {
  transform: rotate(180deg);
}

.cDhzJq9Jzpfq4giFOUGt {
  padding: 6px;
  max-height: 300px;
  overflow-y: auto;
}

.XztJHrVXevU91m3oDh7L {
  height: 1px;
  background: var(--vnsc-border, #2a2a2a);
  margin: 6px 0;
}

.DaC6QXFvpdsCcYFCESum {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
  font-size: 12px;
}

.JnBjoAuS7ND6c5aKErMn {
  color: var(--vnsc-text-secondary, #a0a0a0);
}

.yau91i0Na1Zk6HKiDAWl {
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.PAMbvpSqbIKpSM6An7hD {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 4px;
}

.LpuPQ5O5m3eWiBd5VBct {
  padding: 8px 10px;
  background: var(--vnsc-bg-input, #0d1117);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  outline: none;
  transition: border-color 0.15s;
}

.LpuPQ5O5m3eWiBd5VBct:focus {
  border-color: var(--vnsc-accent, #2962ff);
}

.IczBMQLcv8By00T4oZze {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.lrp6kkCshoSU0yOHzFnJ,
.jjzFaVinTiASQlNMqqL6 {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s;
}

.lrp6kkCshoSU0yOHzFnJ {
  background: var(--vnsc-accent, #2962ff);
  color: white;
  border: none;
}

.lrp6kkCshoSU0yOHzFnJ:hover {
  background: var(--vnsc-accent-hover, #1a52e0);
}

.jjzFaVinTiASQlNMqqL6 {
  background: transparent;
  color: var(--vnsc-text-primary, #e0e0e0);
  border: 1px solid var(--vnsc-border, #2a2a2a);
}

.jjzFaVinTiASQlNMqqL6:hover {
  background: var(--vnsc-bg-hover, #232838);
}

.nqt4YBxNwSH3qszhXlpo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ADXHHQBku5KkNQvASnAT {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s;
}

.ADXHHQBku5KkNQvASnAT:hover {
  background: var(--vnsc-bg-hover, #232838);
}

.ADXHHQBku5KkNQvASnAT.kPKYte0MPSIqoRdEW1dL {
  background: var(--vnsc-accent-subtle, rgba(41, 98, 255, 0.15));
  color: var(--vnsc-accent, #2962ff);
}

.zuTXOgvnCvjAlL8dH9zY {
  font-size: 14px;
  width: 20px;
  text-align: center;
}

.k8mAVDP7AAQiGRsFg4Tg {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kvfyFxf7Wu34GSYpdsal {
  color: var(--vnsc-accent, #2962ff);
  font-weight: bold;
}

.ExSkRha9gry_FfIj0rsI {
  display: flex;
  gap: 4px;
}

.Ugi0piBmOSQiNAbyfiOA {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}

.Ugi0piBmOSQiNAbyfiOA:hover {
  background: var(--vnsc-bg-hover, #232838);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.TqeE6ctYAgQ22lsPGEtH {
  padding: 16px;
  text-align: center;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 12px;
}

.ay0Ct1V2gaq19xzYMmjJ {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.EbqtAbTSHqa1nHWPmJUa {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.15s;
}

.EbqtAbTSHqa1nHWPmJUa:hover {
  background: var(--vnsc-bg-hover, #232838);
}

.RjreBaMAMzzpJSWsjfYa {
  width: 16px;
  height: 16px;
  accent-color: var(--vnsc-accent, #2962ff);
  cursor: pointer;
}

.PxWN48JXkA4UXFstHbBW {
  font-size: 13px;
  color: var(--vnsc-text-primary, #e0e0e0);
}

.d6zoJPCRpfSX9gvuQjXk {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 0;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s;
}

.d6zoJPCRpfSX9gvuQjXk:hover {
  background: var(--vnsc-bg-hover, #232838);
}

.rlV0Te2FP2XbzxaasUGI {
  font-size: 16px;
  width: 24px;
  text-align: center;
}

.X2oDGDppyuulcimyOqHA {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: linear-gradient(135deg, rgba(41, 98, 255, 0.12), rgba(26, 82, 214, 0.08));
  border: 1px solid rgba(41, 98, 255, 0.2);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 4px 8px;
  width: calc(100% - 16px);
  box-sizing: border-box;
}

.X2oDGDppyuulcimyOqHA:hover {
  background: linear-gradient(135deg, rgba(41, 98, 255, 0.2), rgba(26, 82, 214, 0.15));
  border-color: rgba(41, 98, 255, 0.4);
}

.TtkEJsJibXf5t5PeTEt1 {
  font-size: 18px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.CZwaH2PwCfC9TXNOlzAU {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.cHfw8js69gjoWkcsP41q {
  font-weight: 600;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.3;
}

.knvEdlpLyzc9h750U6xw {
  font-size: 10px;
  color: #94a3b8;
  line-height: 1.3;
}

/* Drawing Tools Section */
._bt4NlklXQ8v1FtJNi_2 {
  padding: 4px 0;
}

._bt4NlklXQ8v1FtJNi_2:first-child {
  padding-top: 0;
}

.evBQDByVMorgpqbqVno_ {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vnsc-text-muted, #787b86);
  padding: 0 10px 4px;
}

.TFrfyjkDAMiVU8Z4gjts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  padding: 0 6px;
}

.mwppbtTgjEBCZAYNS6Jf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 6px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  min-height: 48px;
  position: relative;
}

.mwppbtTgjEBCZAYNS6Jf:hover {
  background: var(--vnsc-bg-hover, #232838);
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.mwppbtTgjEBCZAYNS6Jf:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(41, 98, 255, 0.3);
  border-color: var(--vnsc-accent, #2962ff);
}

.mwppbtTgjEBCZAYNS6Jf.kPKYte0MPSIqoRdEW1dL {
  background: rgba(41, 98, 255, 0.15);
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.mwppbtTgjEBCZAYNS6Jf.kPKYte0MPSIqoRdEW1dL:hover {
  background: rgba(41, 98, 255, 0.25);
}

.QKtv4f25afRLqY9lQOo6 {
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.oKzcd15ByH_oSko4oMfH {
  font-size: 9px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.JcCgLAf031jzjxuZll5n {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 7px;
  color: var(--vnsc-text-muted, #787b86);
  background: var(--vnsc-bg-input, #0d1117);
  padding: 1px 3px;
  border-radius: 2px;
  font-family: var(--vnsc-font-mono, ui-monospace, SFMono-Regular, monospace);
}

.Vg8vVdJj4VRiSID_KBvQ {
  position: absolute;
  top: 3px;
  left: 3px;
  font-size: 9px;
  color: var(--vnsc-accent, #2962ff);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.mwppbtTgjEBCZAYNS6Jf:hover .Vg8vVdJj4VRiSID_KBvQ,
.mwppbtTgjEBCZAYNS6Jf:focus-within .Vg8vVdJj4VRiSID_KBvQ {
  opacity: 1;
}

.Vg8vVdJj4VRiSID_KBvQ.kPKYte0MPSIqoRdEW1dL {
  opacity: 1;
}

.n4LlfOqjzKrCgJ1QGWf7 {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--vnsc-border, #2a2a2a);
}

.tOGpe9u6QaKj4kpNQlsp {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}

.tOGpe9u6QaKj4kpNQlsp button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 10px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  min-height: 36px;
}

.tOGpe9u6QaKj4kpNQlsp button:hover:not(:disabled) {
  background: var(--vnsc-bg-hover, #232838);
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.tOGpe9u6QaKj4kpNQlsp button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(41, 98, 255, 0.3);
  border-color: var(--vnsc-accent, #2962ff);
}

.tOGpe9u6QaKj4kpNQlsp button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.g_n0wV_0rG1jKGMhhV61 {
  background: var(--vnsc-danger-bg, #2a1a1a) !important;
  border-color: var(--vnsc-danger-border, #442222) !important;
  color: var(--vnsc-danger-text, #f87171) !important;
}

.g_n0wV_0rG1jKGMhhV61:hover:not(:disabled) {
  background: var(--vnsc-danger-hover, #3a2a2a) !important;
  border-color: var(--vnsc-danger-border-hover, #553333) !important;
}

/* Responsive */
@media (max-width: 640px) {
  .cqi5lJDHnVd3otinppUO {
    min-width: 260px;
    max-width: calc(100vw - 24px);
    right: -12px;
  }
}

/* Theme grid */
.MyeLV1ledeSVff9ICdwQ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 8px 12px;
}

.fDTBFnbm5c5_oP613sgd {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.fDTBFnbm5c5_oP613sgd:hover {
  background: var(--vnsc-bg-hover, #232838);
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.ONH1t0HAOqwkXUK25Eze {
  background: rgba(41, 98, 255, 0.15);
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.k1uzF5mIl9FOBT7Zjh3g {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .mwppbtTgjEBCZAYNS6Jf,
  .tOGpe9u6QaKj4kpNQlsp button,
  .SJ46B69dTrZRCluRjCLL {
    border-width: 2px;
  }

  .mwppbtTgjEBCZAYNS6Jf.kPKYte0MPSIqoRdEW1dL,
  .SJ46B69dTrZRCluRjCLL.CdkqT2_DTKiDaSzFRzto {
    outline: 2px solid currentColor;
    outline-offset: -2px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .mwppbtTgjEBCZAYNS6Jf,
  .tOGpe9u6QaKj4kpNQlsp button,
  .SJ46B69dTrZRCluRjCLL,
  .Vg8vVdJj4VRiSID_KBvQ,
  .SoGd_UTNZLyccp28uCsO {
    transition: none;
  }
}

/* Context indicator */
.HmI0qZlM8VihAzq9LjEs {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}

.uNU066SHgiw_x1xyKt5q {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.HmI0qZlM8VihAzq9LjEs[data-context="workspace"] {
  color: #2962ff;
}

.HmI0qZlM8VihAzq9LjEs[data-context="workspace"] .uNU066SHgiw_x1xyKt5q {
  background: #2962ff;
}

.HmI0qZlM8VihAzq9LjEs[data-context="chart"] {
  color: #089981;
}

.HmI0qZlM8VihAzq9LjEs[data-context="chart"] .uNU066SHgiw_x1xyKt5q {
  background: #089981;
}

/* Print styles */
@media print {
  .cqi5lJDHnVd3otinppUO {
    display: none;
  }
}

/* ── Mobile Bottom Sheet ────────────────────────────────────────────── */
.e_miSGi_Z2FrbLfiGkNR {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 10000;
  pointer-events: auto;
}

.exCXbtYs4HXKW2S6SL2o {
  width: 100%;
  max-width: 500px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--vnsc-bg-secondary, #1e222d);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease-out;
  will-change: transform;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-bottom: none;
}

.GS1oj1VvVYTma3t9DZcg {
  width: 100%;
  height: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}

.uggb2KfKgIKKpTAYkP9B {
  width: 40px;
  height: 4px;
  background-color: var(--vnsc-text-muted, #64748b);
  border-radius: 2px;
}

.UWmeHZbYYjys3KPtLjjP {
  flex: 1;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px 16px;
}

.UWmeHZbYYjys3KPtLjjP::-webkit-scrollbar {
  width: 6px;
}

.UWmeHZbYYjys3KPtLjjP::-webkit-scrollbar-track {
  background: transparent;
}

.UWmeHZbYYjys3KPtLjjP::-webkit-scrollbar-thumb {
  background: var(--vnsc-text-muted, #64748b);
  border-radius: 3px;
}

/* Mobile timeframe grid */
.tjCPZLSJvQWtxY58T3L0 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 8px 12px;
}

.apSshK7S16D8SoY2rFHi {
  min-height: 44px;
  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
}

.apSshK7S16D8SoY2rFHi:active,
.wsyLeHUtEe3NTBp8ldeK {
  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.XoFFWhQYusVqsds1OpUY {
  appearance: auto;
}

.vfnahWmFIQAC4QI6D0vS {
  display: flex; align-items: center; gap: 8px;
  width: calc(100% - 24px); margin: 4px 12px;
  padding: 10px 12px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px; cursor: pointer;
  transition: all 0.15s;
}

.vfnahWmFIQAC4QI6D0vS:active,
.uE8t_AbXd2T7rjGCyuPB {
  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.WAJrLbMEOQE68DGV4OfD {
  width: 100%; padding: 8px 12px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 14px;
}

.dJmtr4CpTcjwZctKhc13 {
  padding: 6px 12px;
}

.S03Jyjj42OL6aahMRRLg {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 8px 12px;
}

.ldwRXkoVmjX_V12u8NIl {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 12px;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s;
}
.ldwRXkoVmjX_V12u8NIl:last-child {
  border-bottom: none;
}
.ldwRXkoVmjX_V12u8NIl:hover {
  background: var(--vnsc-bg-hover, #232838);
}
.ldwRXkoVmjX_V12u8NIl.kPKYte0MPSIqoRdEW1dL {
  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));
  color: var(--vnsc-accent, #2962ff);
}
.Q_y6Iyehj6aU2jb3Wd4a {
  flex: 1;
  text-align: left;
  background: transparent;
  border: none;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  padding: 4px 0;
}

.ByiR4Gf_5BmzHrCgm_ld .ldwRXkoVmjX_V12u8NIl {
  border-width: 2px;
}

.YDrM0oWj5r2NXr3IGfgw {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  padding: 6px 12px;
}

/* Mobile chart list */
.PFpc9pQQeuM7AoongaIA {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 12px;
}

.Ce2hpAkBD8C8Hl1FHNSk {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: var(--vnsc-bg-tertiary, #1a1f2e);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;
}

.Ce2hpAkBD8C8Hl1FHNSk:active,
.rW5N_abpQlTGEeil8dB7 {
  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));
  border-color: var(--vnsc-accent, #2962ff);
  color: var(--vnsc-accent, #2962ff);
}

.WVUWKxe4MUFNKer2YaMd {
  font-weight: 600;
  flex: 1;
}

.peQnbMY4SGa1UYUlWoKv {
  font-size: 11px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-weight: 500;
}

.rW5N_abpQlTGEeil8dB7 .peQnbMY4SGa1UYUlWoKv {
  color: var(--vnsc-accent, #2962ff);
}

.FBWHkg5h9uPyjupTHbM8 {
  font-size: 14px;
  color: var(--vnsc-accent, #2962ff);
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .exCXbtYs4HXKW2S6SL2o {
    border-width: 2px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .exCXbtYs4HXKW2S6SL2o {
    transition: none;
  }
}

.cWZQi8befx_nFyZGPRmq {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 4px 12px;
}

.qDaJrYs5rYW9fuwQ5jUI {
  min-height: 44px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
}

.qDaJrYs5rYW9fuwQ5jUI:active,
.qDaJrYs5rYW9fuwQ5jUI.kPKYte0MPSIqoRdEW1dL {
  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  border-color: var(--vnsc-accent, #22d3ee);
  color: var(--vnsc-accent, #22d3ee);
}

.fXTgmsoGXF6xVHFHI2x0 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 4px 12px;
}

.tmXzsWe9nB6SCDYT4UJg {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s;
}

.PgMoJ_VEDslclJntRUuo {
  margin: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--vnsc-accent, #22d3ee);
  cursor: pointer;
}

.sJiXywby5d_7EyX1ZD4t {
  font-size: 12px;
  font-weight: 500;
  color: var(--vnsc-text-primary, #e2e8f0);
}`, "",{"version":3,"sources":["webpack://./src/widget/components/SystemMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8DAA8D;EAC9D,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qFAAqF;EACrF,wCAAwC;EACxC,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,oFAAoF;EACpF,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,2DAA2D;EAC3D,kDAAkD;AACpD;;AAEA;EACE,wDAAwD;EACxD,iEAAiE;AACnE;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,+BAA+B;IAC/B,oBAAoB;EACtB;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;;IAKE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF;;AAEA,0EAA0E;AAC1E;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mDAAmD;EACnD,4BAA4B;EAC5B,6BAA6B;EAC7B,0CAA0C;EAC1C,mCAAmC;EACnC,sBAAsB;EACtB,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8DAA8D;EAC9D,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;;EAEE,2DAA2D;EAC3D,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,wBAAwB,EAAE,gBAAgB;EAC1C,kBAAkB;EAClB,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe,EAAE,eAAe;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,2DAA2D;EAC3D,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,WAAW,EAAE,iBAAiB;EAC9B,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oDAAoD;EACpD,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,2DAA2D;EAC3D,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;;EAEE,iEAAiE;EACjE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oEAAoE;EACpE,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C","sourcesContent":[".menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  z-index: 1000;\r\n  min-width: 280px;\r\n  max-width: 360px;\r\n  max-height: 80vh;\r\n  overflow-y: scroll;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\r\n  font-size: 13px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.menu::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.menu::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.menu::-webkit-scrollbar-thumb {\r\n  background: var(--vnsc-text-muted, #64748b);\r\n  border-radius: 3px;\r\n}\r\n\r\n.section {\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.section:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.sectionHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.sectionTitle {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.dropdownTrigger {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.dropdownTrigger:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  border-color: var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.dropdownTrigger.open {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.currentWorkspace,\r\n.currentLayout {\r\n  max-width: 140px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.syncStatus {\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.dropdownArrow {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  transition: transform 0.15s;\r\n}\r\n\r\n.dropdownTrigger.open .dropdownArrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.dropdown {\r\n  padding: 6px;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.dropdownDivider {\r\n  height: 1px;\r\n  background: var(--vnsc-border, #2a2a2a);\r\n  margin: 6px 0;\r\n}\r\n\r\n.workspaceInfo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n.workspaceLabel {\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n}\r\n\r\n.workspaceName {\r\n  font-weight: 500;\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.newWorkspaceInput {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 8px 4px;\r\n}\r\n\r\n.input {\r\n  padding: 8px 10px;\r\n  background: var(--vnsc-bg-input, #0d1117);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  outline: none;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.input:focus {\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.inputActions {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.buttonPrimary,\r\n.buttonSecondary {\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.buttonPrimary {\r\n  background: var(--vnsc-accent, #2962ff);\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n.buttonPrimary:hover {\r\n  background: var(--vnsc-accent-hover, #1a52e0);\r\n}\r\n\r\n.buttonSecondary {\r\n  background: transparent;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.buttonSecondary:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n}\r\n\r\n.workspaceItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.dropdownItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.dropdownItem:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n}\r\n\r\n.dropdownItem.active {\r\n  background: var(--vnsc-accent-subtle, rgba(41, 98, 255, 0.15));\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.dropdownItemIcon {\r\n  font-size: 14px;\r\n  width: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.workspaceItemName {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.activeIndicator {\r\n  color: var(--vnsc-accent, #2962ff);\r\n  font-weight: bold;\r\n}\r\n\r\n.workspaceActions {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.actionButton {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s, color 0.15s;\r\n}\r\n\r\n.actionButton:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.emptyState {\r\n  padding: 16px;\r\n  text-align: center;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  font-size: 12px;\r\n}\r\n\r\n.fileInput {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  opacity: 0;\r\n}\r\n\r\n.syncToggleLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.syncToggleLabel:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n}\r\n\r\n.syncToggleInput {\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: var(--vnsc-accent, #2962ff);\r\n  cursor: pointer;\r\n}\r\n\r\n.syncToggleLabelText {\r\n  font-size: 13px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.actionItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 0;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.actionItem:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n}\r\n\r\n.actionIcon {\r\n  font-size: 16px;\r\n  width: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.upgradeItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  background: linear-gradient(135deg, rgba(41, 98, 255, 0.12), rgba(26, 82, 214, 0.08));\r\n  border: 1px solid rgba(41, 98, 255, 0.2);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  margin: 4px 8px;\r\n  width: calc(100% - 16px);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.upgradeItem:hover {\r\n  background: linear-gradient(135deg, rgba(41, 98, 255, 0.2), rgba(26, 82, 214, 0.15));\r\n  border-color: rgba(41, 98, 255, 0.4);\r\n}\r\n\r\n.upgradeIcon {\r\n  font-size: 18px;\r\n  width: 24px;\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.upgradeContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n.upgradeLabel {\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.upgradeDesc {\r\n  font-size: 10px;\r\n  color: #94a3b8;\r\n  line-height: 1.3;\r\n}\r\n\r\n/* Drawing Tools Section */\r\n.drawingToolsSection {\r\n  padding: 4px 0;\r\n}\r\n\r\n.drawingToolsSection:first-child {\r\n  padding-top: 0;\r\n}\r\n\r\n.sectionLabel {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  color: var(--vnsc-text-muted, #787b86);\r\n  padding: 0 10px 4px;\r\n}\r\n\r\n.toolGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 4px;\r\n  padding: 0 6px;\r\n}\r\n\r\n.drawingToolButton {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 3px;\r\n  padding: 8px 6px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  min-height: 48px;\r\n  position: relative;\r\n}\r\n\r\n.drawingToolButton:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.drawingToolButton:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(41, 98, 255, 0.3);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.drawingToolButton.active {\r\n  background: rgba(41, 98, 255, 0.15);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.drawingToolButton.active:hover {\r\n  background: rgba(41, 98, 255, 0.25);\r\n}\r\n\r\n.toolIcon {\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.toolLabel {\r\n  font-size: 9px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n}\r\n\r\n.toolShortcut {\r\n  position: absolute;\r\n  top: 3px;\r\n  right: 3px;\r\n  font-size: 7px;\r\n  color: var(--vnsc-text-muted, #787b86);\r\n  background: var(--vnsc-bg-input, #0d1117);\r\n  padding: 1px 3px;\r\n  border-radius: 2px;\r\n  font-family: var(--vnsc-font-mono, ui-monospace, SFMono-Regular, monospace);\r\n}\r\n\r\n.favoriteStar {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  font-size: 9px;\r\n  color: var(--vnsc-accent, #2962ff);\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.drawingToolButton:hover .favoriteStar,\r\n.drawingToolButton:focus-within .favoriteStar {\r\n  opacity: 1;\r\n}\r\n\r\n.favoriteStar.active {\r\n  opacity: 1;\r\n}\r\n\r\n.drawingToolsExtras {\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.extraControls {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.extraControls button {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  padding: 8px 10px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  min-height: 36px;\r\n}\r\n\r\n.extraControls button:hover:not(:disabled) {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.extraControls button:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px rgba(41, 98, 255, 0.3);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.extraControls button:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.clearAllBtn {\r\n  background: var(--vnsc-danger-bg, #2a1a1a) !important;\r\n  border-color: var(--vnsc-danger-border, #442222) !important;\r\n  color: var(--vnsc-danger-text, #f87171) !important;\r\n}\r\n\r\n.clearAllBtn:hover:not(:disabled) {\r\n  background: var(--vnsc-danger-hover, #3a2a2a) !important;\r\n  border-color: var(--vnsc-danger-border-hover, #553333) !important;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 640px) {\r\n  .menu {\r\n    min-width: 260px;\r\n    max-width: calc(100vw - 24px);\r\n    right: -12px;\r\n  }\r\n}\r\n\r\n/* Theme grid */\r\n.themeGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.themeGridItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 10px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.themeGridItem:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.themeGridItemActive {\r\n  background: rgba(41, 98, 255, 0.15);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.themeSwatch {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  border: 1px solid rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* High contrast mode */\r\n@media (prefers-contrast: high) {\r\n  .drawingToolButton,\r\n  .extraControls button,\r\n  .dropdownTrigger {\r\n    border-width: 2px;\r\n  }\r\n\r\n  .drawingToolButton.active,\r\n  .dropdownTrigger.open {\r\n    outline: 2px solid currentColor;\r\n    outline-offset: -2px;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .drawingToolButton,\r\n  .extraControls button,\r\n  .dropdownTrigger,\r\n  .favoriteStar,\r\n  .dropdownArrow {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n/* Context indicator */\r\n.contextIndicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.contextDot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.contextIndicator[data-context=\"workspace\"] {\r\n  color: #2962ff;\r\n}\r\n\r\n.contextIndicator[data-context=\"workspace\"] .contextDot {\r\n  background: #2962ff;\r\n}\r\n\r\n.contextIndicator[data-context=\"chart\"] {\r\n  color: #089981;\r\n}\r\n\r\n.contextIndicator[data-context=\"chart\"] .contextDot {\r\n  background: #089981;\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  .menu {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ── Mobile Bottom Sheet ────────────────────────────────────────────── */\r\n.mobileOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  pointer-events: auto;\r\n}\r\n\r\n.mobileBottomSheet {\r\n  width: 100%;\r\n  max-width: 500px;\r\n  max-height: 85vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--vnsc-bg-secondary, #1e222d);\r\n  border-top-left-radius: 16px;\r\n  border-top-right-radius: 16px;\r\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.3);\r\n  transition: transform 0.2s ease-out;\r\n  will-change: transform;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-bottom: none;\r\n}\r\n\r\n.mobileHandleBarContainer {\r\n  width: 100%;\r\n  height: 24px;\r\n  min-height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: grab;\r\n}\r\n\r\n.mobileHandleBar {\r\n  width: 40px;\r\n  height: 4px;\r\n  background-color: var(--vnsc-text-muted, #64748b);\r\n  border-radius: 2px;\r\n}\r\n\r\n.mobileContent {\r\n  flex: 1;\r\n  overflow-y: scroll;\r\n  -webkit-overflow-scrolling: touch;\r\n  padding: 0 16px 16px;\r\n}\r\n\r\n.mobileContent::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.mobileContent::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.mobileContent::-webkit-scrollbar-thumb {\r\n  background: var(--vnsc-text-muted, #64748b);\r\n  border-radius: 3px;\r\n}\r\n\r\n/* Mobile timeframe grid */\r\n.timeframeGridMobile {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.timeframeChip {\r\n  min-height: 44px;\r\n  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.timeframeChip:active,\r\n.timeframeChipActive {\r\n  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.mobileSelect {\r\n  appearance: auto;\r\n}\r\n\r\n.mobileActionBtn {\r\n  display: flex; align-items: center; gap: 8px;\r\n  width: calc(100% - 24px); margin: 4px 12px;\r\n  padding: 10px 12px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px; cursor: pointer;\r\n  transition: all 0.15s;\r\n}\r\n\r\n.mobileActionBtn:active,\r\n.mobileActionBtnActive {\r\n  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.mobileChartTypeSelect {\r\n  width: 100%; padding: 8px 12px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 14px;\r\n}\r\n\r\n.mobilePackSection {\r\n  padding: 6px 12px;\r\n}\r\n\r\n.mobileFeaturesGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.mobileActionRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 12px 12px;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n.mobileActionRow:last-child {\r\n  border-bottom: none;\r\n}\r\n.mobileActionRow:hover {\r\n  background: var(--vnsc-bg-hover, #232838);\r\n}\r\n.mobileActionRow.active {\r\n  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n.mobileActionRowMain {\r\n  flex: 1;\r\n  text-align: left;\r\n  background: transparent;\r\n  border: none;\r\n  color: inherit;\r\n  font-size: inherit;\r\n  cursor: pointer;\r\n  padding: 4px 0;\r\n}\r\n\r\n.highContrast .mobileActionRow {\r\n  border-width: 2px;\r\n}\r\n\r\n.toolGridMobile {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 4px;\r\n  padding: 6px 12px;\r\n}\r\n\r\n/* Mobile chart list */\r\n.chartListMobile {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 6px 12px;\r\n}\r\n\r\n.chartCard {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  background: var(--vnsc-bg-tertiary, #1a1f2e);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  text-align: left;\r\n}\r\n\r\n.chartCard:active,\r\n.chartCardActive {\r\n  background: var(--vnsc-accent-subtle, rgba(41,98,255,0.15));\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.chartSymbol {\r\n  font-weight: 600;\r\n  flex: 1;\r\n}\r\n\r\n.chartTimeframe {\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  font-weight: 500;\r\n}\r\n\r\n.chartCardActive .chartTimeframe {\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.chartCheck {\r\n  font-size: 14px;\r\n  color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n/* High contrast mode */\r\n@media (prefers-contrast: high) {\r\n  .mobileBottomSheet {\r\n    border-width: 2px;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .mobileBottomSheet {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.layoutGridCompact {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 8px;\r\n  padding: 4px 12px;\r\n}\r\n\r\n.gridItemCompact {\r\n  min-height: 44px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.gridItemCompact:active,\r\n.gridItemCompact.active {\r\n  background-color: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.syncOptionsCompactMobile {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 8px;\r\n  padding: 4px 12px;\r\n}\r\n\r\n.syncOptionMobile {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-height: 44px;\r\n  background-color: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  padding: 0 10px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.syncCheckboxMobile {\r\n  margin: 0;\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: var(--vnsc-accent, #22d3ee);\r\n  cursor: pointer;\r\n}\r\n\r\n.syncLabelTextMobile {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `cqi5lJDHnVd3otinppUO`,
	"section": `AuEMYFldJNgHfFqSsbzH`,
	"sectionHeader": `BG7ycaHZ_5XZbLTn4QGK`,
	"sectionTitle": `zEvYc1yD3q8BTJXdBXT8`,
	"dropdownTrigger": `SJ46B69dTrZRCluRjCLL`,
	"open": `CdkqT2_DTKiDaSzFRzto`,
	"currentWorkspace": `POyYWUNhynn7c1zGVhkm`,
	"currentLayout": `cgg3EGQmYgKCfFP22ZXQ`,
	"syncStatus": `LYB9ngFbNmcXnnLmfzOR`,
	"dropdownArrow": `SoGd_UTNZLyccp28uCsO`,
	"dropdown": `cDhzJq9Jzpfq4giFOUGt`,
	"dropdownDivider": `XztJHrVXevU91m3oDh7L`,
	"workspaceInfo": `DaC6QXFvpdsCcYFCESum`,
	"workspaceLabel": `JnBjoAuS7ND6c5aKErMn`,
	"workspaceName": `yau91i0Na1Zk6HKiDAWl`,
	"newWorkspaceInput": `PAMbvpSqbIKpSM6An7hD`,
	"input": `LpuPQ5O5m3eWiBd5VBct`,
	"inputActions": `IczBMQLcv8By00T4oZze`,
	"buttonPrimary": `lrp6kkCshoSU0yOHzFnJ`,
	"buttonSecondary": `jjzFaVinTiASQlNMqqL6`,
	"workspaceItem": `nqt4YBxNwSH3qszhXlpo`,
	"dropdownItem": `ADXHHQBku5KkNQvASnAT`,
	"active": `kPKYte0MPSIqoRdEW1dL`,
	"dropdownItemIcon": `zuTXOgvnCvjAlL8dH9zY`,
	"workspaceItemName": `k8mAVDP7AAQiGRsFg4Tg`,
	"activeIndicator": `kvfyFxf7Wu34GSYpdsal`,
	"workspaceActions": `ExSkRha9gry_FfIj0rsI`,
	"actionButton": `Ugi0piBmOSQiNAbyfiOA`,
	"emptyState": `TqeE6ctYAgQ22lsPGEtH`,
	"fileInput": `ay0Ct1V2gaq19xzYMmjJ`,
	"syncToggleLabel": `EbqtAbTSHqa1nHWPmJUa`,
	"syncToggleInput": `RjreBaMAMzzpJSWsjfYa`,
	"syncToggleLabelText": `PxWN48JXkA4UXFstHbBW`,
	"actionItem": `d6zoJPCRpfSX9gvuQjXk`,
	"actionIcon": `rlV0Te2FP2XbzxaasUGI`,
	"upgradeItem": `X2oDGDppyuulcimyOqHA`,
	"upgradeIcon": `TtkEJsJibXf5t5PeTEt1`,
	"upgradeContent": `CZwaH2PwCfC9TXNOlzAU`,
	"upgradeLabel": `cHfw8js69gjoWkcsP41q`,
	"upgradeDesc": `knvEdlpLyzc9h750U6xw`,
	"drawingToolsSection": `_bt4NlklXQ8v1FtJNi_2`,
	"sectionLabel": `evBQDByVMorgpqbqVno_`,
	"toolGrid": `TFrfyjkDAMiVU8Z4gjts`,
	"drawingToolButton": `mwppbtTgjEBCZAYNS6Jf`,
	"toolIcon": `QKtv4f25afRLqY9lQOo6`,
	"toolLabel": `oKzcd15ByH_oSko4oMfH`,
	"toolShortcut": `JcCgLAf031jzjxuZll5n`,
	"favoriteStar": `Vg8vVdJj4VRiSID_KBvQ`,
	"drawingToolsExtras": `n4LlfOqjzKrCgJ1QGWf7`,
	"extraControls": `tOGpe9u6QaKj4kpNQlsp`,
	"clearAllBtn": `g_n0wV_0rG1jKGMhhV61`,
	"themeGrid": `MyeLV1ledeSVff9ICdwQ`,
	"themeGridItem": `fDTBFnbm5c5_oP613sgd`,
	"themeGridItemActive": `ONH1t0HAOqwkXUK25Eze`,
	"themeSwatch": `k1uzF5mIl9FOBT7Zjh3g`,
	"contextIndicator": `HmI0qZlM8VihAzq9LjEs`,
	"contextDot": `uNU066SHgiw_x1xyKt5q`,
	"mobileOverlay": `e_miSGi_Z2FrbLfiGkNR`,
	"mobileBottomSheet": `exCXbtYs4HXKW2S6SL2o`,
	"mobileHandleBarContainer": `GS1oj1VvVYTma3t9DZcg`,
	"mobileHandleBar": `uggb2KfKgIKKpTAYkP9B`,
	"mobileContent": `UWmeHZbYYjys3KPtLjjP`,
	"timeframeGridMobile": `tjCPZLSJvQWtxY58T3L0`,
	"timeframeChip": `apSshK7S16D8SoY2rFHi`,
	"timeframeChipActive": `wsyLeHUtEe3NTBp8ldeK`,
	"mobileSelect": `XoFFWhQYusVqsds1OpUY`,
	"mobileActionBtn": `vfnahWmFIQAC4QI6D0vS`,
	"mobileActionBtnActive": `uE8t_AbXd2T7rjGCyuPB`,
	"mobileChartTypeSelect": `WAJrLbMEOQE68DGV4OfD`,
	"mobilePackSection": `dJmtr4CpTcjwZctKhc13`,
	"mobileFeaturesGrid": `S03Jyjj42OL6aahMRRLg`,
	"mobileActionRow": `ldwRXkoVmjX_V12u8NIl`,
	"mobileActionRowMain": `Q_y6Iyehj6aU2jb3Wd4a`,
	"highContrast": `ByiR4Gf_5BmzHrCgm_ld`,
	"toolGridMobile": `YDrM0oWj5r2NXr3IGfgw`,
	"chartListMobile": `PFpc9pQQeuM7AoongaIA`,
	"chartCard": `Ce2hpAkBD8C8Hl1FHNSk`,
	"chartCardActive": `rW5N_abpQlTGEeil8dB7`,
	"chartSymbol": `WVUWKxe4MUFNKer2YaMd`,
	"chartTimeframe": `peQnbMY4SGa1UYUlWoKv`,
	"chartCheck": `FBWHkg5h9uPyjupTHbM8`,
	"layoutGridCompact": `cWZQi8befx_nFyZGPRmq`,
	"gridItemCompact": `qDaJrYs5rYW9fuwQ5jUI`,
	"syncOptionsCompactMobile": `fXTgmsoGXF6xVHFHI2x0`,
	"syncOptionMobile": `tmXzsWe9nB6SCDYT4UJg`,
	"syncCheckboxMobile": `PgMoJ_VEDslclJntRUuo`,
	"syncLabelTextMobile": `sJiXywby5d_7EyX1ZD4t`
};
export default ___CSS_LOADER_EXPORT___;
